import Icon from 'components/Icon';
import classNames from 'classnames';
import React, {FC, ReactNode, useState} from 'react';
import style from './style.module.scss';
import {FilterHint} from 'plugins/modules/filter/components/FilterHint';

interface IProps {
    children: ReactNode;
    hint?: string;
    isDefaultOpen: boolean;
    title: string;
}

export const FilterCollapseSecondLevel: FC<IProps> = ({children, hint, isDefaultOpen, title}) => {
    const [isVisible, setIsVisible] = useState(isDefaultOpen);

    const toggle = () => {
        setIsVisible((visibility) => !visibility);
    };

    return (
        <div className={classNames({[style.active]: isVisible})}>
            <button data-skeleton-item={true} className={style.button} onClick={toggle} type={'button'}>
                <span className={style.title}>{title}</span>
                {hint && <FilterHint text={hint} />}
                <Icon className={style.icon} icon={'arrow-collapse'} />
            </button>
            <div className={style.contentBlock}>{children}</div>
        </div>
    );
};
